module.exports = __webpack_public_path__ + "img/folder-icon.dd1bc176.png";